import React from 'react';
import s from './s.module.less';
import { Collapse, Tabs } from 'antd';
import ResourceCenter from './components/ResourceCenter';
import useKlarityResource from 'hooks/useKlarityResource';
import { getHelpCenterActiveKey, setHelpCenterActiveKey } from 'utils/sessionStorage';
import useProviderServiceFlag from 'hooks/useProviderServiceFlag';

const HelpCenter = () => {
    const [activedKey, setActivedKey] = React.useState<string>('1');
    const [resourceData] = useKlarityResource();
    const [flag] = useProviderServiceFlag();
    const isKlarity = !!flag?.klarityServiceFlag;
    const [currentActiveKey, setCurrentActiveKey] = React.useState<string[] | undefined>(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19']);

    const hasResource = resourceData && resourceData.length > 0 && isKlarity;

    React.useEffect(() => {
        if (!resourceData) {
            return;
        }
        if (resourceData.length === 0) {
            setActivedKey('1');
        }
    }, [resourceData]);

    React.useEffect(() => {
        const key = getHelpCenterActiveKey();
        if (key) {
            setActivedKey(key);
            setHelpCenterActiveKey(undefined);
        }
    }, []);

    return (
        <div className={s.wrap}>
            <div className={s.header}>Help center</div>
            {/* <Collapse items={items} bordered={false} defaultActiveKey={['1', '2', '3', '4']} /> */}
            <Tabs activeKey={activedKey} onChange={(e) => setActivedKey(e)}>
                <Tabs.TabPane
                    tab={
                        <div className={`${s.tabItem} ${activedKey === '1' ? s.actived : ''}`}>
                            <div className={s.icon} />
                            <div className={s.tabText}>Frequently asked questions</div>
                        </div>
                    }
                    key="1"
                >
                    <>
                        <Collapse
                            onChange={(key) => {
                                setCurrentActiveKey(key as string[]);
                            }}
                            bordered={false}
                            defaultActiveKey={currentActiveKey}
                        >
                            {/* 新增Doc QA内容 */}
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>Where can I view Klarity’s Billing Policy?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('6') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="6"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>You can view the full Klarity Billing Policy here:<br />
                                        <a href="https://docs.google.com/document/d/1gSn7JXEjMzSNY_H6TIub8W68fNAWdi_TMdwfeRGWrPs/edit?tab=t.0#heading=h.rybk3q70jj6h" target="_blank" rel="noreferrer">🔗 Klarity Billing Policy</a>
                                    </p>
                                </div>
                            </Collapse.Panel>
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>Am I still charged an $80 lead generation fee even if the patient didn’t show up?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('7') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="7"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>Yes. The $80 lead generation fee applies 24 hours after a patient book an appointment with you, regardless of whether they complete their intake or attend the session. If a patient is not a good fit or unresponsive, we recommend reaching out and instructing them to cancel the appointment using their Klarity portal <strong>within 24 hours</strong> to avoid the charge.</p>
                                </div>
                            </Collapse.Panel>
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>How do I refund patients their no-show/late-cancellation fees if necessary?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('8') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="8"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>If a refund is needed for a no-show or late-cancellation fee, please email <a href="mailto:support@kiwihealth.com" target="_blank" rel="noreferrer"><strong>support@kiwihealth.com</strong></a>. Be sure to include the patient’s <strong>first name and last initial</strong>, along with the <strong>appointment date and time</strong>. Our team will review and process the request accordingly.</p>
                                </div>
                            </Collapse.Panel>
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>Can I charge a patient a no-show or late cancellation fee?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('9') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="9"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>Yes — if the patient has a credit card on file, you can charge them:<br />
                                        <ul>
                                            <li><strong>Automatically</strong> through the Klarity portal (if your late cancellation policy is properly set)</li>
                                            <li><strong>Manually</strong>, by updating the appointment status to Patient No Show or Patient Late Cancelled</li>
                                        </ul>
                                    </p>
                                </div>
                            </Collapse.Panel>
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>The patient booked twice or rescheduled — will I be charged twice?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('10') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="10"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>No — you will only be charged <strong>once per unique patient</strong>. If a patient reschedules or accidentally double-books, you will not be double-billed for those leads.</p>
                                </div>
                            </Collapse.Panel>
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>A patient canceled but I still got charged — why?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('11') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="11"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>If a patient cancels through their Klarity portal after the 24-hour booking window, the lead-generation fee is still automatically applied by the system.</p>
                                </div>
                            </Collapse.Panel>
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>How can I make sure I’m fully set up, live, and managing my practice correctly on Klarity?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('12') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="12"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>You can find our full Provider Playbook at the link below. It walks you through everything from setting up your account and going live, to managing your practice and understanding how the platform works from both the provider and patient perspective:<br />
                                        <a href="https://www.figma.com/deck/Pp04xhxNg7ihv6oU4tImh8/Klarity-Health--Playbook?node-id=1-42&t=Ff4gtwRVrDPeNUVt-1" target="_blank" rel="noreferrer">🔗 Klarity Health – Provider Playbook</a><br />
                                        <strong>Password to access: letsgrow2025</strong>
                                    </p>
                                    <p>The playbook includes setup guidance, platform features, patient point of view, and tips for running your practice efficiently. It’s a helpful reference whether you’re newly live or looking to revisit specific parts of your setup, workflow, or platform functionality.</p>
                                </div>
                            </Collapse.Panel>
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>How can I get a summary of patient charges and Klarity lead-generation fees I&#39;ve paid?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('13') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="13"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>To request a summary of charges—both fees you have billed to patients and lead-generation fees billed to you—please email <a href="mailto:support@kiwihealth.com" target="_blank" rel="noreferrer">support@kiwihealth.com</a>. Include the date range you're requesting, and our team will provide a detailed breakdown. The Transactions tab is currently in development as part of our product roadmap, and it will soon be available on your Kiwi Health web app. You’ll be notified once available.</p>
                                </div>
                            </Collapse.Panel>
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>When am I charged Klarity&#39;s lead-generation fee?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('14') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="14"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>The $80 lead-generation fee is charged <strong>24 hours after a patient books an appointment</strong>—regardless of whether the visit occurs or is later canceled.<br />
                                        The fee is <strong>automatically waived</strong> if the patient cancels themselves <strong>within 24 hours of booking</strong>.
                                    </p>
                                </div>
                            </Collapse.Panel>
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>How do I submit a dispute for a Klarity charge?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('15') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="15"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>You can submit a dispute using this form:<br />
                                        <a href="https://docs.google.com/forms/d/1oOiOs-vyajGs2at3E9kXmBCsiw0aynuX90qQfQKdpOM/viewform?edit_requested=true" target="_blank" rel="noreferrer">🔗 Dispute Form</a><br />
                                        Once submitted, you’ll receive a confirmation email. Our support team will follow up within <strong>5–7 business days</strong>. If additional information is needed to review your request, we’ll reach out directly.
                                    </p>
                                    <p><b>Important:</b> Please do not submit disputes through Stripe. This can significantly delay the review process and may result in your Klarity profile being de-listed for a longer period until the issue is resolved. <strong>Refunds will not be eligible in these cases</strong>.</p>
                                </div>
                            </Collapse.Panel>
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>Where do no-show and late-cancellation fees get deposited?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('16') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="16"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>These fees are paid directly to your linked Stripe account. Klarity <strong>deducts a 5% transaction fee</strong> from the total collected.</p>
                                </div>
                            </Collapse.Panel>
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>Why am I de-listed?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('17') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="17"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>Providers are automatically de-listed if a lead-generation fee payment fails. To be re-listed, you’ll need to update your payment method. Once the charge processes successfully, your Klarity profile will be restored automatically.</p>
                                </div>
                            </Collapse.Panel>
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>How do I communicate with patients directly?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('18') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="18"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>Use the <strong>Inbox feature</strong> in your Kiwi Health app. This ensures your messages are sent within the system, improving visibility and ensuring proper documentation in case of disputes.<br />
                                        We also recommend using the term <strong>“Klarity”</strong> when referring to appointment bookings, communications, and patient portal access. Avoid using “Kiwi Health” or “Kiwi EHR,” as patients may not recognize these names, leading to confusion and missed communication.
                                    </p>
                                </div>
                            </Collapse.Panel>
                            <Collapse.Panel
                                header={<div className={s.collapseHeader}>How should I instruct patients to cancel or reschedule their appointment?
                                    <div className={`${s.iconBox} ${currentActiveKey?.includes('19') ? s.expandIcon : ''}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M19 9L12 16L5 9" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>}
                                key="19"
                                showArrow={false}
                            >
                                <div className={s.text}>
                                    <p>Always direct patients to cancel or reschedule <strong>through their Klarity patient portal</strong>. Cancellations made through Klarity are properly logged and can protect you from unnecessary lead charges or disputes.</p>
                                </div>
                            </Collapse.Panel>
                        </Collapse>

                        {/* <div className={s.contact}>
                    <div className={s.label}>Contact us:</div>
                    <a href={`mailto:${Email.klarity_provider_support}`} target="_blank" rel="noreferrer">{Email.klarity_provider_support}</a>
                </div> */}
                    </>
                </Tabs.TabPane>
                {
                    hasResource &&
                    <Tabs.TabPane
                        tab={
                            <div className={`${s.tabItem} ${s.tabItem2} ${activedKey === '2' ? s.actived : ''}`}>
                                <div className={s.icon} />
                                <div className={s.tabText}>Klarity policies & resources</div>
                            </div>
                        }
                        key="2"
                    >
                        <ResourceCenter data={resourceData} />
                    </Tabs.TabPane>
                }
            </Tabs>
        </div>
    );
};

export default HelpCenter;
